module.exports = __webpack_public_path__ + "img/GCvs51.6611326d.png";